import CharaDescription from '@/ts/model/CharaDescription'
import StageItemDescription from '@/ts/model/StageItemDescription'

export default class StageDescription {
  public chara: CharaDescription
  public items: StageItemDescription[] = []
  public thumbData?: string

  constructor (chara: CharaDescription, items?: StageItemDescription[], thumbData?: string) {
    this.chara = chara
    if (items) {
      this.items = items
    }
    this.thumbData = thumbData
  }
}
